export function initGlobalState() {
  if (typeof global.lombardo === "undefined") {
    global.lombardo = {
      selected: [],
      total_images_to_load: 0,
      rendered: [],
      property_rendered: [],
    };
  }
}

export function isPropertySelected(property_id: string) : boolean {
  initGlobalState();
  const look_for: string = String(property_id).toLowerCase();

  for(const pid of global.lombardo.selected){
    if(String(pid).toLowerCase() === look_for){
      return true;
    }
  }
  return false;
}
